import moment from './moment'

import constants from '../../config/constants'

/**
 * Format date to the backEnd format
 * @param {String} date
 * @param {String} dateFormat
 * @returns {String}
 */
export default (date, dateFormat) =>
  moment(date, dateFormat, true).format(constants.backEndDateFormat)
